'use client'

import React from 'react'
import { Security } from '@okta/okta-react'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { useRouter } from 'next/navigation'
import config from '../okta-login-widget/config'

const oktaAuth = new OktaAuth({
  issuer: config.oidc.issuer,
  clientId: config.oidc.clientId,
  redirectUri: config.oidc.redirectUri,
})

const OktaProvider = ({ children }: { children: any }) => {
  const router = useRouter()

  const restoreOriginalUri = async (_: any, originalUri: any) => {
    router.replace(toRelativeUrl(originalUri || '/', window.location.origin))
  }

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  )
}

export default OktaProvider
